import { primary } from "../../../assets/colorPallet";

export default function YearBar({ data }) {
  return (
    <div className="flex items-center font-semibold text-center text-white mt-5 mb-10">
      <div
        style={{ backgroundColor: primary, minWidth: (16 + 10 * data?.length) + "em" }}
        className="absolute left-0 w-full h-12 z-10"
      />
      <div className="z-20" style={{ minWidth: "12em" }} />
      {data?.map((date) => (
        <div className="z-20" style={{ minWidth: "10em" }}>
          {date}
        </div>
      ))}
    </div>
  );
}
